import '../../css/pages/product-page.scss';
import 'drift-zoom/dist/drift-basic.css';

import { setupBuyGrids } from '../modules/buy-grid/buy-grid';
import lazyHTML from '../modules/lazy-html/lazy-html';
import { addOffCanvasPanelListeners } from '../modules/off-canvas-panel/off-canvas-panel';
import { isMobile } from '../modules/mobile-detect/mobile-detect';
import { addEventListernerWithPromiseForData } from '../modules/utility-functions/async-event-assets';
import { scrollSnapIndicators } from '../modules/scroll-snap-indicators/scroll-snap-indicators';
import RemarkableZoomer from '../modules/remarkable/zoomer';
import { stockRequestFormHandler } from '../modules/stock-request/stock-request';
import carouselThumbs from '../modules/component-carousel/carousel-thumbs';
import loadComponentCarousel from '../modules/component-carousel/load-component-carousel';
import { gaTracking } from '../modules/event/event';
import { scrollIntoView } from '../modules/scroll-into-view/scroll-into-view';
import { recaptchaFunction } from '../modules/recaptcha-functions/recaptcha-functions';
import { imageTooltipSetup } from '../modules/image-tooltip/image-tooltip';
import eImageSwap from '../modules/e-image-swap/e-image-swap';

function init() {
    console.log('You are on the products page');
    
    setupBuyGrids(document.querySelectorAll('.buy-grid:not(.product-sizes)'));
    lazyHTML();
    addOffCanvasPanelListeners();
    scrollSnapIndicators();
    productQty();
    stockRequestFormHandler();
    amountSold();
    gaTracking("view_item", false, {
        currency: document.querySelector<HTMLInputElement>('input[name="currency"]').value,
        value: document.querySelector<HTMLInputElement>('input[name="productValue"]').value,
        type: document.querySelector<HTMLInputElement>('input[name="pageType"]').value,
        items: [
            {
                item_id: document.querySelector<HTMLInputElement>('input[name="productID"]').value,
                item_name: document.querySelector<HTMLInputElement>('input[name="productName"]').value,
                item_brand: document.querySelector<HTMLInputElement>('.product-info').getAttribute('data-brand'),
                item_ean: document.querySelector<HTMLInputElement>('.product-info').getAttribute('data-ean'),
                item_category: document.querySelector<HTMLInputElement>('input[name="productCategory"]').value
            }
        ]
    });
    if (window.innerWidth >= 768) new RemarkableZoomer().initialize();

    // Lazy-load Swiper/carousel so it can share an async chunk across page entries
    loadComponentCarousel().then(() => {
        carouselThumbs();
        eImageSwap('.product-page-container', '.product-images-container .swiper-slide-active img');
    });

    if (isMobile()) {
        import('../modules/fake-sticky/fake-sticky').then((fakeSticky) => {
            fakeSticky.init();
        });

        addEventListernerWithPromiseForData('quick.basket.data');
    }

    spxFormInit();
    reviewShow();
    reviewScroll();
    stickyBuyGrid();
    imageTooltipSetup();
}

const stickyBuyGrid = () => {
    const addBagSticky = document.querySelector<HTMLElement>('.sticky-add-to-bag-button');
    const addBag = document.querySelector<HTMLElement>('.add-to-bag-button');

    if (addBagSticky && addBag) {
        const originalOffset = addBagSticky.getBoundingClientRect().top + window.pageYOffset;

        const isMobile = window.innerWidth <= 768;

        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];

            if (isMobile) {
                // On mobile add fixed only if scrolled past and not intersecting
                if (!entry.isIntersecting && window.pageYOffset > originalOffset) addBag.classList.add('fixed');
                else addBag.classList.remove('fixed');                
            } else {
                // On desktop add fixed as soon as element is out of view
                if (!entry.isIntersecting) addBag.classList.add('fixed');
                else addBag.classList.remove('fixed');                
            }
        }, {
            threshold: 0,
        });

        observer.observe(addBagSticky);
    }
};

const reviewShow = () => {
    setTimeout(() => {
        const reviews = document.querySelector<HTMLElement>('.feefo-product-stars-widget');
        const reviewsHeight = reviews?.clientHeight;
        const reviewsTab = document.getElementById('reviewCard') as HTMLElement;
        if (reviews && reviewsHeight > 0) reviewsTab?.classList.remove('d-none');
    }, 2000);
};

const reviewScroll = () => {
    const starWidget = document.querySelector<HTMLElement>('.feefo-review-scroll');
    starWidget?.addEventListener('click', e => {
        e.preventDefault();
        scrollIntoView(document.getElementById('feefo-product-review-widgetId'), { scrollUp: 80, scrollDown: 80 });
    });
}

export const productQty = () => {
    const qtyButtons = document.querySelectorAll('.basket-item__quantity-btn') as NodeListOf<HTMLElement>;
    qtyButtons.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const isDecrease = btn.dataset.title == "decrease";
            let currentQty = document.getElementById('productQty') as HTMLInputElement;
            let visibleQty = document.querySelector('.js-product-qty') as HTMLSpanElement;
            let qtyValue = parseInt(currentQty.value);
            if (isDecrease && qtyValue > 1) qtyValue -= 1;
            else if (isDecrease && qtyValue < 2) return;
            else qtyValue += 1;
            currentQty.value = qtyValue.toString();
            visibleQty.innerText = qtyValue.toString();
        });
    });   
};

const amountSold = () => {
    const popover = document.querySelector('.products-sold') as HTMLElement;
    const url = `/product/product/numbersoldajax?productID=${document.querySelector<HTMLInputElement>('[name="productId"]')?.value}`
    fetch(url, {
        method: 'POST'
    })
    .then((resp) => resp.json())
    .then((data) => {
        if (data.sold > 0 && popover) {            
            popover.classList.remove('d-none');
            popover.innerHTML = data.text;
            setTimeout(() => {
                popover.classList.add('enter');
                setTimeout(() => {
                    popover.classList.add('exit');
                }, 10000);
            }, 1000);
        }
    })
    .catch(function (err) {
        console.warn('Something went wrong.', err);
    });
};

const spxFormInit = () => {
    const spxForm = document.getElementById('spxForm') as HTMLFormElement;
    const url = spxForm?.getAttribute('action');
    if (spxForm) {
        const toggleBtn = document.querySelector('.js-toggle-spx-form') as HTMLButtonElement;
        toggleBtn?.addEventListener('click', () => { spxForm.classList.toggle('show'); });

        spxForm?.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitButton = spxForm.querySelector<HTMLButtonElement>('button[type="submit"]');
            submitButton.classList.add('disabled');

            const formInfo = new FormData(spxForm as HTMLFormElement);
            let result = await recaptchaFunction();

            if (result.success) {
                fetch(url, {
                    method: 'POST',
                    body: formInfo
                })
                    .then(r => {
                        return r.json();
                    })
                    .then(data => {

                        const alertBox = spxForm.querySelector('.alert') as HTMLElement;
                        alertBox.classList.remove('alert-danger', 'alert-success');

                        if (data.success) {
                            alertBox.innerHTML = "Thank you for your enquiry.";
                            alertBox.classList.add('alert-success');
                            
                        } else {
                            alertBox.classList.add('alert-danger');
                            let errorMessage = '';
                            data.errors.forEach(error => {
                                errorMessage += `<span>* ${error}</span></br>`;
                                alertBox.innerHTML = errorMessage;
                            });
                        }

                        alertBox.classList.remove('d-none');
                        
                        gaTracking("SPX Enquiry form", false, {
                            method: "Site form"
                        });
                    });
            } else alert('error')

            setTimeout(() => { submitButton.classList.remove('disabled'); }, 1000);
        });
    }
};

const exit = () => {
    console.log('product-page: Exit');
};

window.productPage = {
    init,
    exit
};
